@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';

.ciProducts {
  display: flex;
  padding: $spacing-16;
  align-items: flex-start;
  flex-wrap: wrap;
  &--noPadding {
    padding: 16px 0 0 0;
  }

  .ghf-menu-link {
    border-radius: 6px;
    padding: .5rem;
    display: block;
    &:hover {
      background: $color-header-hover-blue;
    }
  }
  &-heading {
    padding: .5rem;
    display: block;
    color: $color-red-default !important;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    &.ghf-menu-link:hover {
      background: transparent;
      color: #ce1400 !important;
    }
  }

  &-column {
    display: flex;
    flex-direction: column;
    flex: 1 0 0;

    &-list {
      margin: 0;
      margin-block: 0;
      padding-inline: 0;
      list-style-type: none;
      padding: 0 $spacing-8 $spacing-16 $spacing-8;
      line-height: 1rem;
      .ghf-menu-listItem {
        display: block;
        padding: 0;
      }
    }
  }
  &-image {
    flex-basis: 100%;
    flex-grow: 1;
    &--tshirts {
      @include image('assets/header/products-tshirts.jpg');
      background-repeat: no-repeat;
      background-position: center bottom;
      background-size: contain;
      height: 300px;
      margin-top: 45px;
    }
    &--apparel {
      @include image('assets/header/products-apparel.jpg');
      background-repeat: no-repeat;
      background-position: center bottom;
      background-size: contain;
      height: 300px;
      margin-top: 10px;

    }
    &--promoproducts {
      @include image('assets/header/products-promo.jpg');
      background-repeat: no-repeat;
      background-position: center bottom;
      background-size: contain;
      height: 300px;
    }
  }

  &-new {
    display: flex;
    gap: 10px;
    padding: 0 $spacing-8;
    align-items: center;
  }

  &-inlineImage {
    width: 25px;
    display: inline-block;
    position: relative;
    padding: 0 0 0 3px;
    vertical-align: middle;
  }

  &-moreWaysToShop-icon {
    display: flex;
    gap: 5px;
    align-items: center;

    .ciProducts-inlineImage {
      width: 20px;
    }
  }
}
// special override
.ciProducts-heading--newArrivals {
  .ghf-menu-listItem {
    padding-left: 0;
    padding-top: 0;
  }
}

@media only screen and (min-width: 1300px) {
  .ciProducts-image {
    background-size: contain;
    background-position: center bottom;
    height: 400px;
    &--tshirts {
      margin-top: 30px;
    }
  }
}

.ciProducts-column-list,
.ciProducts-column-list,
.ciProducts-column-list,
.ciProducts-column-list-unclickable-title,
.ciProducts-column-list-clickable-title {
  padding: 0 $spacing-16 $spacing-16 $spacing-16;
  li {
    list-style-type: none;
    display: block;
    padding: 0;
    align-items: center;
    align-self: stretch;
    border-radius: 4px;
    box-sizing: inherit;
    a {
      border-radius: 6px;
      padding: 0.5rem;
      display: block;
      font-size: $typography-body-short1-size;
      text-decoration: none;
      color: $color-gray-slate-dark;
      &:link, &:visited {
        color: $color-gray-slate-dark;
      }
      &:hover {
        background: rgba(30, 57, 210, 0.05);
        color: $color-blue-default;
      }
    }
  }

  &-unclickable-title, &-clickable-title {
    overflow: hidden;
    color: var(--neutral-text-secondary, rgba(0, 0, 0, 0.57));
    text-overflow: ellipsis;
    /* UI Text/Default */
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: 125%; /* 1.25rem */
    
    a {
      font-size: 1rem !important;
    }
  }

  &-unclickable-title {
    padding: 0.5rem !important;
  }

  &-clickable-title {
    color: var(--neutral-text-primary, rgba(0, 0, 0, 0.86));
  }
}
